

export const siteConfig = {
  name: "OnePlace Deal",
  tagline: "Le bon professionnel, à portée de message",
  shortDescription:
    "OnePlace Deal met en relation des particuliers avec des professionnels de confiance  puis laisse la conversation se poursuivre directement sur WhatsApp ou Telegram.",
  longDescription:
    "OnePlace Deal est une vitrine qui présente des prestataires de services indépendants : leur profil, leurs prestations, leurs tarifs et leurs réalisations. Aucune messagerie interne, aucun paiement en ligne : vous choisissez un professionnel, vous consultez ses informations, puis vous le contactez directement via WhatsApp ou Telegram pour organiser la prestation.",
  url: "https://OnePlacedeal.com",
  email: "contact@OnePlacedeal.example",
  supportPhone: "+125946656598",
  whatsappNumber: "+125946656598",
  telegramHandle: "OnePlacedeal_officiel",
  address: "Montreal, Canada",
  legalEntity: "OnePlace Deal SARL",
  foundedYear: 2024,
  defaultCurrency: "USD" as const,
  socials: {
    facebook: "https://facebook.com/OnePlacedeal",
    instagram: "https://instagram.com/OnePlacedeal",
    x: "https://x.com/OnePlacedeal",
    linkedin: "https://linkedin.com/company/OnePlacedeal",
  },
  stats: {
    professionals: 240,
    citiesCovered: 12,
    countriesCovered: 6,
    satisfactionRate: 97,
  },
};

export const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "Profils", to: "/profils" },
  { label: "Produits", to: "/produits" },
  { label: "À propos", to: "/a-propos" },
];

export const footerLinks = {
  plateforme: [
    { label: "Accueil", to: "/" },
    { label: "Tous les profils", to: "/profils" },
    { label: "Tous les produits", to: "/produits" },
  ],
  entreprise: [
    { label: "À propos", to: "/a-propos" },
    { label: "Contact", to: "/contact" },
    { label: "Mes favoris", to: "/favoris" },
  ],
  legal: [
    { label: "Mentions légales", to: "/mentions-legales" },
    { label: "Politique de confidentialité", to: "/confidentialite" },
    { label: "Conditions d'utilisation", to: "/conditions-utilisation" },
  ],
};
